/* ============================================================================
   Odesse — "Bundle & Save" editorial enhancement
   ----------------------------------------------------------------------------
   Companion to odesse-bundle-restyle.css. The tiered-pricing widget
   (#bogo-offers-container) is built at runtime by product-bundle-builder.js,
   so the few changes that CSS can't do are applied here, after it renders:

     1. "40% OFF / 50% OFF"  ->  per-bottle price hero ("$53.97 / Per Bottle")
     2. "$X each + FREE Shipping" badge  ->  "Most Popular" / "Best Value"
     3. the struck-through original price is moved up under the card title
     4. the per-tier scent dropdowns are collected into ONE tray under the cards

   It keeps itself in sync as the shopper switches tiers / scents — via a
   MutationObserver on a stable ancestor (so it survives the builder replacing
   the widget) plus a click delegate, and is fully idempotent. No pricing,
   variant or cart behaviour is changed.

   ----------------------------------------------------------------------------
   INSTALL
     1. Upload this file and odesse-bundle-restyle.css to the theme /assets.
     2. In layout/theme.liquid, just before </head>, add:

          {%- if template.name == 'product' -%}
            {{ 'odesse-bundle-restyle.css' | asset_url | stylesheet_tag }}
            <script src="{{ 'odesse-bundle-enhance.js' | asset_url }}" defer></script>
          {%- endif -%}

     Load order doesn't matter — the observer waits for the widget.
   ========================================================================== */
(function () {
  'use strict';

  var CONTAINER_ID = 'bogo-offers-container';
  var TRAY_ID = 'odesse-variant-tray';
  var LEAD_LABEL = 'Choose your scents'; // first scent label doubles as the heading

  var observer = null;
  var queued = false;

  function container() { return document.getElementById(CONTAINER_ID); }

  /* a node that persists even when the builder re-renders the widget */
  function wrapper() {
    var W = container();
    return (W && (W.closest('.product--bogo-offer-wrapper') || W.parentNode)) || null;
  }

  function toNumber(s) { return parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0; }
  function money(n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); }

  function qty(opt) {
    return opt.getAttribute('data-bogo-qty') || (opt.dataset ? opt.dataset.bogoQty : '') || '';
  }
  function offerId(opt) {
    return opt.getAttribute('data-offer-id') || (opt.dataset ? opt.dataset.offerId : '') || '';
  }

  function selectedOption(W) {
    var opts = W.querySelectorAll('.bogo-offer-option');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].classList.contains('selected')) return opts[i];
    }
    return opts[0] || null;
  }

  /* find the card a selectors block belongs to, by id ("offer3-selectors") */
  function ownerOption(W, selectorsId) {
    var offer = (selectorsId || '').replace('-selectors', '');
    if (!offer) return null;
    var opts = W.querySelectorAll('.bogo-offer-option');
    for (var i = 0; i < opts.length; i++) {
      if (offerId(opts[i]) === offer) return opts[i];
    }
    return null;
  }

  function ensureTray(W) {
    var tray = document.getElementById(TRAY_ID);
    if (!tray) {
      tray = document.createElement('div');
      tray.id = TRAY_ID;
    }
    if (tray.previousElementSibling !== W) {
      W.parentNode.insertBefore(tray, W.nextSibling);
    }
    return tray;
  }

  /* the builder labels the first dropdown "Item #1" — relabel it to the heading */
  function relabelLead(tray) {
    var first = tray.querySelector('.bogo-variant-label');
    if (first) {
      if (first.textContent.trim() !== LEAD_LABEL) first.textContent = LEAD_LABEL;
      first.classList.add('odc-lead');
    }
  }

  /* Deterministic: the SELECTED tier's selectors (matched by offer-id) live in
     the tray; every other tier's selectors go back inside their own card (where
     the CSS keeps them hidden). Matching by id — not by render timing — is what
     makes this reliable when the builder swaps tiers asynchronously.           */
  function syncTray(W, tray) {
    var sel = selectedOption(W);
    if (!sel) return;
    var selOffer = offerId(sel);
    var scope = tray.parentNode || W.parentNode;
    var all = scope.querySelectorAll('.bogo-variant-selectors');
    for (var i = 0; i < all.length; i++) {
      var block = all[i];
      var offer = (block.id || '').replace('-selectors', '');
      if (offer === selOffer) {
        if (block.parentNode !== tray) tray.appendChild(block);
      } else {
        var owner = ownerOption(W, block.id);
        if (owner && block.parentNode !== owner) owner.appendChild(block);
      }
    }
  }

  function enhance() {
    var W = container();
    if (!W) return;
    document.body.classList.add('odesse-bundle-enhanced');

    var opts = W.querySelectorAll('.bogo-offer-option');
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var q = qty(opt);
      var priceEl = opt.querySelector('.bogo-offer-price');
      var price = priceEl ? toNumber(priceEl.textContent) : 0;

      /* 1. per-bottle hero in place of the "% OFF" line.
            The label is editor-driven (data-per-bottle-label). */
      var disc = opt.querySelector('.bogo-offer-discount');
      if (disc && q && price && !disc.querySelector('.odc-pb')) {
        var per = price / parseFloat(q);
        var pbLabel = opt.getAttribute('data-per-bottle-label') || 'Per Bottle';
        disc.innerHTML =
          '<span class="odc-pb">' + money(per) + '</span>' +
          '<span class="odc-pbl">' + pbLabel + '</span>';
      }

      /* 2. recommendation pill is now fully editor-driven (rendered
            server-side from each offer's "Top Recommendation Pill"), so the
            enhancer no longer overrides it. */

      /* 3. wrap the bundle total so it sits on its own line */
      if (priceEl && priceEl.parentNode && !priceEl.parentNode.classList.contains('odc-totals')) {
        var wrap = document.createElement('div');
        wrap.className = 'odc-totals';
        priceEl.parentNode.insertBefore(wrap, priceEl);
        wrap.appendChild(priceEl);
      }

      /* 4. move the struck-through original up under the title */
      var original = opt.querySelector('.bogo-offer-original');
      var textBox = opt.querySelector('.bogo-offer-text');
      if (original && textBox && original.parentNode !== textBox) {
        textBox.appendChild(original);
      }
    }

    /* 5. collect scent dropdowns into a single tray */
    var tray = ensureTray(W);
    syncTray(W, tray);
    relabelLead(tray);
  }

  /* run with the observer paused so our own writes don't re-trigger it */
  function run() {
    queued = false;
    if (observer) observer.disconnect();
    try { enhance(); }
    catch (e) { if (window.console && console.warn) console.warn('[odesse-bundle]', e); }
    startObserver();
  }

  /* setTimeout (not requestAnimationFrame) — rAF is paused in background tabs,
     which would freeze the tray sync until the tab regains focus.              */
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(run, 0);
  }

  function startObserver() {
    var root = wrapper();
    if (!root) return;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* Belt-and-suspenders: the builder may handle tier selection out-of-band in a
     way the observer misses, so also re-sync on any click inside a tier card.   */
  function onClick(e) {
    if (e.target.closest && e.target.closest('.bogo-offer-option')) {
      setTimeout(schedule, 0);
      setTimeout(schedule, 200); // catch the builder's async tier swap
    }
  }

  function init() {
    document.addEventListener('click', onClick, true);
    // poll quickly so the styled widget appears as soon as the builder renders
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (container()) { clearInterval(timer); run(); }
      else if (tries > 150) { clearInterval(timer); } // give up after ~12s
    }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();